export default __webpack_public_path__ + "static/media/logo-05-amresorts.fc4237d1.png";